
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M10.281 12.376a1.308 1.308 0 001.939 0l.627-.7a1.306 1.306 0 012.273.942l-.047.934a1.3 1.3 0 001.371 1.371l.934-.047a1.305 1.305 0 01.941 2.273l-.694.627a1.306 1.306 0 000 1.939l.694.627a1.305 1.305 0 01-.941 2.273l-.934-.047a1.305 1.305 0 00-1.371 1.371l.047.934a1.306 1.306 0 01-2.273.942l-.627-.7a1.308 1.308 0 00-1.939 0l-.627.7a1.306 1.306 0 01-2.273-.942l.047-.934a1.307 1.307 0 00-1.371-1.371l-.934.047a1.306 1.306 0 01-.942-2.273l.695-.627a1.308 1.308 0 000-1.939l-.695-.627a1.306 1.306 0 01.942-2.273l.934.047a1.305 1.305 0 001.371-1.371l-.047-.934a1.306 1.306 0 012.273-.942l.627.7z"}}),_c('path',{attrs:{"d":"M9.375 18.751a1.875 1.875 0 103.75 0 1.875 1.875 0 00-3.75 0h0zM21.638 8a.375.375 0 100 .75.375.375 0 000-.75h0"}}),_c('path',{attrs:{"d":"M24.194 4.848a.75.75 0 01.971.971l-.5 1.286a.749.749 0 00.229.856l1.075.864a.75.75 0 01-.355 1.326l-1.363.211a.749.749 0 00-.627.626l-.211 1.364a.75.75 0 01-1.326.355l-.864-1.075a.751.751 0 00-.856-.23l-1.286.5a.75.75 0 01-.971-.971l.5-1.286a.749.749 0 00-.229-.856l-1.075-.865a.749.749 0 01.355-1.324l1.363-.211a.751.751 0 00.627-.627l.211-1.362a.749.749 0 011.325-.355l.865 1.075a.75.75 0 00.856.229l1.286-.501z"}})])])
          )
        }
      }
    